import "./trix/init.js"
import "./trix/customizations.js"
import "./trix/mentions.js"
import "./trix/uploads.js"

window.addEventListener("trix-initialize", (e) => {
  Utility.TrixMentions.prepare($(e.target))
  Utility.TrixCustomizations.prepare($(e.target))
})

document.addEventListener('DOMContentLoaded', () => {
  Utility.TrixUploads.prepare()
})
